import { Dispatch, SetStateAction, createContext, useContext, useState } from "react";
import { useParams } from "react-router";
import { ICharges } from "src/api/OrderRepository";

type Props = {
  children: React.ReactNode;
};

type CartCtxt  = {
  slug_id?: string;
  shop_id?: string;
  menu_id?: string;
  order_id?: string;
  table_id?: string;
  phone?: string;
  setPhone: Dispatch<SetStateAction<string | undefined>>;
  code?: string;
  setCode: Dispatch<SetStateAction<string | undefined>>;
  charges: ICharges[],
  setCharges: Dispatch<SetStateAction<ICharges[]>>,
  totalCharge: () => number
}
const Context = createContext<CartCtxt>({} as CartCtxt);

export const CartProvider : React.FC<Props> = ({children}) => {

  const params = useParams<{slug_id?: string, shop_id?: string, menu_id? : string, order_id?: string, table_id?: string}>();

  const slug_id = params.slug_id;
  const shop_id = params.shop_id;
  const menu_id = params.menu_id;
  const order_id = params.order_id;
  const table_id = params.table_id;
  const [phone, setPhone] = useState<string|undefined>();
  const [code, setCode] = useState<string|undefined>();

  const [charges, setCharges] = useState<ICharges[]>([]);

  const totalCharge = () => {
    let total = 0;
    charges.forEach(x => total += x.amount);
    return total;
  }

  return (
    <Context.Provider
      value={{
        slug_id: slug_id,
        shop_id: shop_id,
        menu_id: menu_id,
        table_id: table_id,
        order_id: order_id,
        phone,
        setPhone,
        code,
        setCode,
        charges,
        setCharges,
        totalCharge
      }}
    >
      {children}
    </Context.Provider>
  );

}

export const useCartContext = () => {

  const context = useContext(Context);

  if(context.slug_id === undefined) throw new Error('useCartContext must be inside CartProvider');

  return context;

}
